import { Box, Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { getDistanceBettwenTodayAndMillisecondsInWords } from 'components/actions/utils/formatDate';
import { CardViewChipRow, CardViewTextRow } from 'ui/viewComponents';
import { Audience, AudienceType } from './models/segmentModel';
import { Row } from 'ui/Flex';
import { AudienceCardHeader } from './utils/audiencesUI';

interface SegmentDetailCardComponentProps {
    segment: Audience;
    onGrantPerkButtonClick: () => void;
    onDelete: () => void;
    disabled?: boolean;
}

export const SegmentDetailBetaCardComponent = ({
    segment,
    onGrantPerkButtonClick,
    onDelete,
    disabled
}: SegmentDetailCardComponentProps) => {
    const { title, description, type, expiryHorizon, count } = segment;

    return (
        <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
            <AudienceCardHeader>
                <Typography variant="h6">{title}</Typography>
                <Row gutter>
                    <Button
                        onClick={onDelete}
                        color="error"
                        variant="outlined"
                        disabled={disabled}
                        size="small"
                    >
                        Permanently Delete
                    </Button>
                    <Button
                        onClick={onGrantPerkButtonClick}
                        color="primary"
                        variant="contained"
                        disabled={disabled}
                        size="small"
                    >
                        Grant Perk
                    </Button>
                </Row>
            </AudienceCardHeader>
            <Divider />
            <Box padding={2}>
                <Grid container spacing={2} direction="row">
                    <Divider />
                    <Grid
                        size={{
                            xs: 12,
                            md: 3
                        }}
                    >
                        <Grid container spacing={2} direction="column">
                            <CardViewChipRow title="Type" value={type} />
                            {segment.type !== AudienceType.PERSISTENT && (
                                <CardViewTextRow
                                    title="Expires after"
                                    value={getDistanceBettwenTodayAndMillisecondsInWords(expiryHorizon)}
                                />
                            )}
                        </Grid>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 7
                        }}
                    >
                        <CardViewTextRow title="Description" value={description} />
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 2
                        }}
                    >
                        <CardViewTextRow title="Customers in this Audience" value={count.toString()} />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};
